/**
 * APP PRINCIPAL - ACCOUNTS
 * 
 * Router simple sin guards.
 * Solo autentica, no valida acceso.
 */

import React, { useCallback, useEffect } from 'react';
import { Routes, Route } from 'react-router-dom';
import AuthRouter from './routes/AuthRouter';
import { AuthIntentProvider } from './contexts/AuthIntentContext';
import { authListenerService } from '@shared/services/authListenerService';

const App: React.FC = () => {
  const onAuthDebugEvent = useCallback((event: string, session: unknown) => {
    const s = session as { user?: { email?: string }; expires_at?: number } | null;
    console.log('[AUTH EVENT]', event, {
      user: s?.user?.email ?? null,
      expiresAt: s?.expires_at ?? null,
    });
  }, []);

  useEffect(() => {
    console.log('[App] Configurando listener de auth events...');
    const unsubscribe = authListenerService.subscribe(onAuthDebugEvent);

    return () => {
      console.log('[App] Limpiando listener de auth events');
      unsubscribe();
    };
  }, [onAuthDebugEvent]);

  return (
    <AuthIntentProvider>
      <Routes>
        <Route path="/*" element={<AuthRouter />} />
      </Routes>
    </AuthIntentProvider>
  );
};

export default App;
